export const modifyCommunicationPreferences = (pref, selection) => {
  return selection
    ? [...pref, 'marketing_sms'] // Add 'marketing_sms'
    : pref.filter(item => item !== 'marketing_sms'); // Remove 'marketing_sms'
};

export const determineSmsOptIn = (user, preference) =>
  user?.communicationPreferences.includes(preference);

export const shouldAllowUpdate = (preferences, smsOptIn) => {
  return smsOptIn
    ? preferences.includes('marketing_sms')
    : !preferences.includes('marketing_sms');
};
